import webservice from '../../../../services/webservice';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getProfileQuestions = createAsyncThunk('ProfileQuestions/getProfileQuestionslist', async (payload) => {
    try {
        const crypto = require('../../../../services/crypto');
        let requestBody = {};
        if (payload) {
            requestBody = { EncData: crypto.AesEncrypt(payload) };
        }

        const response = await fetch(webservice + 'api/getProfileQuestionslist', {
            method: 'POST',
            body: Object.keys(requestBody).length > 0 ? JSON.stringify(requestBody) : undefined,
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
});

export const getProfileQuestionDetails = createAsyncThunk('ProfileQuestions/ProfileQuestiondetails', async (id) => {
    try {
        const response = await fetch(webservice + 'api/ProfileQuestiondetails', {
            method: 'POST',
            body: JSON.stringify({ id }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
});

export const addProfileQuestion = createAsyncThunk('ProfileQuestions/addProfileQuestion', async (payload) => {
    try {
        const crypto = require('../../../../services/crypto');
        const encryptedPayload = crypto.AesEncrypt(payload);

        const response = await fetch(webservice + 'api/addProfileQuestion', {
            method: 'POST',
            body: JSON.stringify({ EncData: encryptedPayload }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
});

export const updateProfileQuestion = createAsyncThunk('ProfileQuestions/updateProfileQuestion', async (payload) => {
    try {
        const crypto = require('../../../../services/crypto');
        const encryptedPayload = crypto.AesEncrypt(payload);

        const response = await fetch(webservice + 'api/updateProfileQuestion', {
            method: 'POST',
            body: JSON.stringify({ EncData: encryptedPayload }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
});

export const deleteProfileQuestion = createAsyncThunk('ProfileQuestions/deleteProfileQuestion', async (id) => {
    try {
        const response = await fetch(webservice + 'api/deleteProfileQuestion', {
            method: 'POST',
            body: JSON.stringify({ data: id }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
});
